import { IListEnumerable } from "yfiles";
import RegularPortCandidateProvider from "./regularPortCandidateProvider";
export default class GroupPortCandidateProvider extends RegularPortCandidateProvider {
    getTargetPortCandidates() {
        return IListEnumerable.EMPTY;
    }
}
